import React from 'react';
import { createRoot } from 'react-dom/client';
import { Route, Switch, Router } from "wouter";
import { Provider } from 'react-redux';
import AccessFeatureList from "@/components/AccessFeatureList.jsx";
import AccessFeature from '@/components/AccessFeature';
import ScrollTopOnNavigation from "@/components/ScrollTopOnNavigation.jsx";
import store from '@/store/store';

const routes = {
  '/': {
    component: AccessFeatureList,
  },
  '/product/:id': {
    component: AccessFeature
  }
};

function Access() {
  return (
    <div id="app-bounds">
      <Provider store={store}>
        <Router base="/access">
          <ScrollTopOnNavigation />
          {Object.entries(routes).map(([path, config]) => {
            const Component = config.component;
            return (
              <Route path={path} key={path}>
                <Component />
              </Route>
            );
          })}
        </Router>
      </Provider>
    </div>
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(document.getElementById('access-app'));
  root.render(<Access />);
});
